import { setAuthed, setInitialized } from "./authStore";

export async function initAuth(): Promise<void> {
  try {
    const res = await fetch("/api/me", { credentials: "include" });
    setAuthed(res.ok);
  } catch {
    setAuthed(false);
  } finally {
    setInitialized(true);
  }
}
